<div class="global-search-wrapper">
  <div class="input-group input-group-sm">
    <span class="input-group-text bg-white border-end-0 px-2">
      <span class="search-icon-slot">
        @if (isLoading) {
          <app-spinner [isLoading]="true" diameter="20" [showText]="false" spinnerColor="primary"></app-spinner>
        } @else {
          <mat-icon class="search-icon">search</mat-icon>
        }
      </span>
    </span>
    <input
      type="text"
      class="form-control filter-input border-start-0"
      placeholder="Search by app name, App ID or SysId…"
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      aria-label="Search applications"
      autocomplete="off"
    />
  </div>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
    panelClass="global-search-panel"
  >
    @for (result of results; track result.appId) {
      <mat-option [value]="result" class="global-search-option">
        <div class="search-option-row">
          <span class="search-option-name">{{ result.name }}</span>
          <span class="search-option-meta">
            @if (result.appId) { <span class="badge bg-light text-secondary border me-1">{{ result.appId }}</span> }
            @if (result.outcome) { <span class="badge outcome-badge">{{ result.outcome }}</span> }
          </span>
        </div>
      </mat-option>
    }
    @if (!isLoading && results.length === 0 && (searchControl.value?.length ?? 0) >= 2) {
      <mat-option disabled class="text-muted small">No results found</mat-option>
    }
  </mat-autocomplete>
</div>
